import { secondsToHours } from '~/utils/time_utils';

export default {
  computed: {
    isTimeBasedMetric() {
      const timeBasedMetrics = [
        'work_time', 'time_spent_in_tool', 'unusual_activity', 'suspicious_activity', 'idle_time', 'manual_time'
      ];

      return timeBasedMetrics.includes(this.rule.metric_type);
    },
    ruleSubtitle() {
      const rule = this.rule;
      const metricType = this.computedMetricType || '';

      if (['unusual_activity', 'suspicious_activity'].includes(rule.metric_type)) {
        let name;

        if (rule.metric_type === 'suspicious_activity') {
          name = 'Suspicious applications';
        } else {
          name = 'Unusual activity';
        }

        return `${metricType} - ${name}`;
      }

      const condition = this.getConditionValue(rule.condition_value);
      const text = `- ${metricType} ${rule.condition} ${condition.value} ${condition.addon}`;

      return text;
    },
  },
  methods: {
    getConditionValue(val) {
      let value, addon;
      const rule = this.rule;

      if (this.isTimeBasedMetric) {
        value = secondsToHours(val);

        if (rule.frequency === 'hourly') {
          addon = 'min/hr';
        } else if (rule.frequency === 'daily' || rule.time_unit === 'per_day') {
          addon = rule.frequency === 'daily' ? 'hr/day' : 'Avg. hr/day';
        } else if (rule.frequency === 'weekly' || rule.time_unit === 'per_week') {
          addon = 'hr/week';
        } else if (rule.frequency === 'monthly' || rule.time_unit === 'per_month') {
          addon = 'hr/month';
        } else {
          console.error(`Unexpected frequency and metric combination ${rule.frequency} ${rule.metric_type}`);
          addon = '';
        }
      } else {
        value = val;
        addon = '%';
      }

      return { addon, value };
    },
  },
};
